import { IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetConstructionField } from '../../../../../queries/useBudgetConstructionField';

interface OtherAmountProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const OtherAmount: React.FC<OtherAmountProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [otherAmount, set_otherAmount] = useBudgetConstructionField<number>(
        propertyGuid,
        (b) => (b.values?.['Land Cost']?.['Other, Describe']?.[0] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Land Cost': { ...b.values?.['Land Cost'], 'Other, Describe': [v, b.values?.['Land Cost']?.['Other, Describe']?.[1] ?? ''] as [number, string] } } })
    );
    const label = 'Other - Amount';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(otherAmount)}
                />
            ) : (
                <MoneyBox
                    id={'otherAmount-landCost'}
                    allowNegative={false}
                    value={otherAmount}
                    onChange={(value) => set_otherAmount(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
